import { Box, Divider, IconButton, InputBase, useTheme } from "@mui/material";
import { useState } from "react";
import CloseIcon from "../svgIcon/CloseIcon";
import FilterIcon from "../svgIcon/FilterIcon";
import SearchIcon from "../svgIcon/SearchIcon";

const AVCTableSearchItem = ({ placeholder, searchText, setSearchText, searchPlaceholderWidth }) => {
  const theme = useTheme();
  const [text, setText] = useState(searchText ? searchText : null);

  const onSearchTextChange = (e) => {
    setText(e.target.value);
  };

  const handleSearch = () => {
    setSearchText(text);
  };
  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: searchPlaceholderWidth || 300,
        height: 36,
        borderRadius: 1,
        border: `1px solid ${theme.palette.grey.g5}`,
        bgcolor: theme.palette.grey.gb,
      }}
    >
      <InputBase
        value={text || ""}
        // autoFocus
        onChange={onSearchTextChange}
        sx={{ ml: 1, flex: 1, backgroundColor: "transparent" }}
        placeholder={placeholder}
        onKeyDown={handleEnterKeyPress}
        inputProps={{ maxLength: 100 }}
      />

      {searchText !== null && text !== null ? (
        <IconButton
          type="button"
          onClick={() => {
            setText(null);
            setSearchText(null);
          }}
        >
          <CloseIcon color={theme.palette.error.main} fontSize="small" />
        </IconButton>
      ) : (
        <IconButton type="button" onClick={handleSearch}>
          <SearchIcon color={theme.palette.grey.g2} fontSize="small" />
        </IconButton>
      )}

      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />

      <IconButton aria-label="filter">
        <FilterIcon color={theme.palette.grey.g2} fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default AVCTableSearchItem;
